import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { Popup, Body, Footer } from '@calendly/ui/components/popup';
import { RadioField } from '@calendly/ui/form/radio-field';
import classNames from 'classnames';
import { useState, forwardRef } from 'react';
const radioButtonCss = "rqkrj8a";
const RadioButton = forwardRef((props, ref) => <RadioField ref={ref} {...props} className={classNames(radioButtonCss, props.className)} />);
const descriptionCss = "d7sgqe6";
const Description = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(descriptionCss, props.className)} />;
});
const buttonContainerCss = "b1l80r8q";
const ButtonContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(buttonContainerCss, props.className)} />;
});
export const RemoveHolidayPopup = ({
  holiday,
  onConfirm,
  onClose
}) => {
  const [scope, setScopeValue] = useState('local');
  const {
    name
  } = holiday;
  return <Popup onClose={onClose} title={I18n.t('publisher.event_type_editor.sections.available_hours.remove_holiday_popup.remove_holiday')} withCloseButton>
      <Body>
        <Description>
          {I18n.t('publisher.event_type_editor.sections.available_hours.remove_holiday_popup.body', {
          holidayName: name
        })}
        </Description>
        <ButtonContainer>
          <RadioButton name="remove-holiday-this-event-type" checked={scope === 'local'} onChange={() => setScopeValue('local')} label={HtmlParser(I18n.t('publisher.event_type_editor.sections.available_hours.remove_holiday_popup.event_type_option'))} />
          <RadioButton name="remove-holiday-all-event-types" checked={scope === 'global'} onChange={() => setScopeValue('global')} label={HtmlParser(I18n.t('publisher.event_type_editor.sections.available_hours.remove_holiday_popup.remove_all_options'))} />
        </ButtonContainer>
      </Body>
      <Footer>
        <Button decoration="secondary-outline" onClick={onClose}>
          {I18n.t('publisher.action.cancel')}
        </Button>
        <Button onClick={() => {
        onConfirm({
          scope,
          holiday
        });
      }}>
          {I18n.t('publisher.event_type_editor.sections.available_hours.remove_holiday_popup.remove_holiday')}
        </Button>
      </Footer>
    </Popup>;
};

require("./remove_holiday_popup.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./remove_holiday_popup.js");